<ng-template
  #templateSelectDropdown="rtConnectedOverlay"
  [origin]="templateSelectDropdownTrigger"
  [width]="220"
  (backdropClick)="templateSelectDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown-scrollable
    [header]="'tlc.dynamic_form.define.change_to' | translate"
    [items]="defineFormControlItems"
    [maxHeight]="300"
    (selectionChange)="changeTemplate.emit($event)"
  />
</ng-template>

<ng-template
  #templateRequired="rtConnectedOverlay"
  (backdropClick)="templateRequired.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown [width]="DropdownWidth.SmallXX">
    <rt-dropdown-item (click)="toggleRequired(true)">
      <rt-icon prefix [name]="requiredOptions.required.icon" />
      {{ requiredOptions.required.label }}
    </rt-dropdown-item>
    <rt-dropdown-item (click)="toggleRequired(false)">
      <rt-icon prefix [name]="requiredOptions.optional.icon" />
      {{ requiredOptions.optional.label }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>

<div cdkDrag class="question" [class.error]="hasError()">
  <div class="question-header">
    <div class="drag-handle" cdkDragHandle>
      <rt-icon name="drag-vertical" />
    </div>
    <div class="content-kind" margin-left-small-xx>
      <rt-button
        #templateSelectDropdownTrigger="rtOverlayOrigin"
        [dropdownOpened]="templateSelectDropdown.open"
        rt-overlay-origin
        (click)="templateSelectDropdown.open = true"
        variant="plain"
      >
        <rt-icon [name]="respondKindIcon()" margin-right-small-xx />
        <span>{{ respondKindName() }}</span>
      </rt-button>
    </div>
    <ng-content select="[header]" />

    <div class="question-header-actions">
      <rt-group variant="horizontal">
        @let controls = defineForm().controls;
        @if ('required' in controls) {
          @let isRequired = controls.required.value;
          <rt-button
            #requiredDropdownTrigger="rtOverlayOrigin"
            [rtTooltip]="'tlc.dynamic_form.define.required' | translate"
            variant="plain"
            rt-overlay-origin
            [dropdownOpened]="templateRequired.open"
            (click)="templateRequired.openAt(requiredDropdownTrigger)"
          >
            @let option = isRequired ? requiredOptions.required : requiredOptions.optional;
            <rt-icon
              [colorToken]="isRequired ? 'colorIconCriticalDefault' : 'colorIconDefault'"
              [name]="option.icon"
            />
            {{ option.label }}
          </rt-button>
        }
        <rt-icon-button
          [rtTooltip]="'tlc.dynamic_form.define.duplicate' | translate"
          (click)="duplicate.emit()"
          variant="plain"
          shape="square"
          iconName="content-copy"
        />
        <rt-icon-button
          [rtTooltip]="'tlc.dynamic_form.define.delete' | translate"
          (click)="delete.emit()"
          class="danger-on-hover"
          variant="plain"
          shape="square"
          iconName="delete"
        />
      </rt-group>
    </div>
  </div>
  <div class="question-body">
    <ng-content />
  </div>
</div>
